import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';

const REPORT_2D_TYPES: ReportType[] = [
  ReportType.ReportType_IOXRay_GP,
  ReportType.ReportType_Pano_GP,
  ReportType.ReportType_Pano_Bitewings,
];

export const isReport2D = (reportType: ReportType | undefined) =>
  reportType !== undefined && REPORT_2D_TYPES.includes(reportType);
